import en from "./en";
import es from "./es";
import pt from "./pt-BR";

const optionLanguage = [
  { key: "pt-BR", value: "pt-BR", file: pt },
  { key: "pt", value: "pt-BR", file: pt },
  { key: "es", value: "es", file: es },
  { key: "en", value: "en", file: en },
  { key: "en-US", value: "en", file: en },
];

const chosenLanguage = optionLanguage.find((e) => e.key === navigator.language);
const translations = chosenLanguage.file || pt;

export default function customTranslate(template, replacements) {
  replacements = replacements || {};

  // Translate
  template = translations[template] || template;

  // Replace
  return template.replace(/{([^}]+)}/g, function (_, key) {
    return replacements[key] || "{" + key + "}";
  });
}
